import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus,
    exportExcel,
    masterEchelon
} from "../../../../../services/adapters/kepegawaian/dukService"

class IndexRepository {

    fetchExportExcel = async (query) => {
        return await apiRequest("get", exportExcel, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }

    fetchEchelon = async (query) => {
        return await apiRequest("get", masterEchelon, {
            params: query
        }, true)
    }
}

export default IndexRepository